import React, { useState, useEffect, useMemo } from 'react';
import uuid from 'uuid/v4';
import _ from 'lodash';
import ColumnHeader from './ColumnHeader';
import FirstHeaderColumn from './FirstHeaderColumn';

import PrivateEyeViewCellContent from './PrivateEyeViewCellContent';
import { setHeightOfColumns } from '../../../util/CrosstabUtils';

import PrivateEyeViewRowHeaders from './PrivateEyeViewRowHeaders';

let rowEndIndex = 100;
let colEndIndex = 100;

function PrivateEyeView({
  tableData,
  handleCrosstabSaveButton,
  highlightRadioButton,
  cellElementList,
  onSort,
  handleHighlightShowButton,
  placeholder,
  warningText,
  toggleCheckVal,
  singleDeleteOperation,
  updateCrosstabGridTitleHeader,
  updateGridData,
  restoreGridTitle,
  handleCrosstabEdit,
  crosstabFootNotes,
  getGridRows,
  saveGridTitle,
  editExpression,
  sortClickToggle,
  partsToShow,
  handleProbabilitiesEditClick,
}) {
  const [scrollStarted, setScrollStarted] = useState(0);
  const [columnHeaderList, setColumnHeaderList] = useState(
    tableData && tableData.columnHeaderList ? tableData.columnHeaderList.slice(0, 100) : []
  );
  const [gridRows, setGridRows] = useState(getGridRows && getGridRows.length > 0 ? getGridRows.slice(0, 100) : []);
  const [totalColumnHeaderList, setTotalColumnHeaderList] = useState(
    tableData && tableData.columnHeaderList ? tableData.columnHeaderList : []
  );

  const [totalGridRowsList, setTotalGridRowsList] = useState(getGridRows || []);

  const [updatedTitleIndex, setUpdatedTitleIndex] = useState(null);
  const [updatedTitleGridType, setUpdatedTitleGridType] = useState(null);

  const handleScrollBarWidth = () => {
    $.fn.hasHScrollBar = () => {
      return $('#main-content-grid').get(0).scrollWidth > $('#main-content-grid').width();
    };
    $.fn.getScrollWidth = () => {
      const $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body');
      const widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
      $outer.remove();
      return 100 - widthWithScroll;
    };
    const isHScrollBar = $('#main-content-grid').hasHScrollBar();
    if (isHScrollBar) {
      const scrollWidth = $().getScrollWidth();
      if ($('.empty-table-last-row').length === 0) {
        $('.main-content-grid-left').append(`<div class="empty-table-last-row" style="height:
          ${scrollWidth}px;line-height:${scrollWidth}px"></div>`);
      }
    }
    $.fn.hasVScrollBar = () => {
      if (!isHScrollBar) {
        if ($('.empty-table-last-row').length !== 0) {
          $('.empty-table-last-row').remove();
        }
        return $('#main-content-grid').get(0).scrollHeight > $('#main-content-grid').height();
      }
      const scrollWidth = $().getScrollWidth();
      return $('#main-content-grid').get(0).scrollHeight + scrollWidth > $('#main-content-grid').height();
    };

    const hasScrollBar = $('#main-content-grid').hasVScrollBar();
    if (hasScrollBar) {
      const scrollWidth = $().getScrollWidth();
      const height = $('#top-header-column .c-table--col:first .c-table-infobox').height();
      const topElemHeight = height + 40;
      if ($('.empty-table-header-col').length === 0) {
        $('.c-table--header .c-table--row').append(`<span class="empty-table-header-col" style="min-width:
          ${scrollWidth}px;width:${scrollWidth}px"><div class="head" style="height:
          ${topElemHeight}px"</div><div class="cell" style="margin-top: ${height}px"></div></span>`);
      }
    } else if ($('.empty-table-header-col').length !== 0) {
      $('.empty-table-header-col').remove();
    }
  };

  const virtualizedGridData = target => {
    const originalRowRecords = getGridRows;
    const scrollTop = target.scrollTop;
    const scrollLeft = target.scrollLeft;
    const scrollHeight = target.scrollHeight;
    const averageRowHeight = scrollHeight / rowEndIndex;
    let averageColWidth = $('#top-header-column .c-table--col:first').width();

    // when scroll is coming down
    if (scrollTop >= rowEndIndex * averageRowHeight * 0.80 && originalRowRecords.length > rowEndIndex) {
      rowEndIndex = rowEndIndex + 50 > originalRowRecords.length ? originalRowRecords.length : rowEndIndex + 50;
      setGridRows(originalRowRecords.slice(0, rowEndIndex));
    }

    averageColWidth = averageColWidth !== undefined && !isNaN(averageColWidth) ? averageColWidth : 200;

    // When scroll is on right side
    if (scrollLeft >= colEndIndex * averageColWidth * 0.80 && totalColumnHeaderList.length > colEndIndex) {
      colEndIndex = colEndIndex + 50 > totalColumnHeaderList.length ? totalColumnHeaderList.length : colEndIndex + 50;
      setColumnHeaderList(totalColumnHeaderList.slice(0, colEndIndex));
    }
  };

  const saveTextChange = text => {
    saveGridTitle(text, "PrivateEye-View");
  };

  const handleContentScroll = e => {
    $('#top-header-column').scrollLeft(e.target.scrollLeft);
    $('#left-menu-content').scrollTop(e.target.scrollTop);
    virtualizedGridData(e.target);
    handleScrollBarWidth();
  };

  const updateGridTitle = (updatedTitleIndex, updatedTitleGridType) => {
    setUpdatedTitleIndex(updatedTitleIndex);
    setUpdatedTitleGridType(updatedTitleGridType);
  };

  const resetSelectedIndex = () => {
    setUpdatedTitleIndex(null);
    setUpdatedTitleGridType(null);
  };

  useEffect(() => {
    setTimeout(() => {
      handleScrollBarWidth();
    }, 2000);
    window.addEventListener('resize', handleScrollBarWidth);
    saveGridTitle('', "PrivateEye-View");
    rowEndIndex = 100;
    colEndIndex = 100;

    return () => {
      window.removeEventListener('resize', handleScrollBarWidth);
      saveGridTitle('', "PrivateEye-View");
      rowEndIndex = 100;
      colEndIndex = 100;

    };
  }, []);

  useEffect(() => {
    if (!_.isEqual(totalColumnHeaderList, tableData.columnHeaderList)) {
      setColumnHeaderList(tableData.columnHeaderList.slice(0, colEndIndex));
      setTotalColumnHeaderList(tableData.columnHeaderList);
    }
  }, [tableData.columnHeaderList]);

  useEffect(() => {
    if (!_.isEqual(totalGridRowsList, getGridRows)) {
      setGridRows(getGridRows.slice(0, rowEndIndex));
      setTotalGridRowsList(getGridRows);
    }
  }, [getGridRows]);

  useEffect(() => {
    handleScrollBarWidth();
  }, [tableData.crosstabPerStudy]);

  const renderColumnHeader = () => {
    const metricsCount = cellElementList.filter(item => item.isVisible);

    return useMemo(() =>
        columnHeaderList.map((item, index) => (
          <ColumnHeader
            key={uuid()}
            columnHeight={setHeightOfColumns(partsToShow, columnHeaderList, toggleCheckVal)}
            header={item}
            rightmost={columnHeaderList.length - 1 === index}
            metricsList={metricsCount}
            metricsCount={metricsCount.length}
            onSort={onSort}
            sortOrder={tableData.sortOrder}
            sortKey={tableData.sortKey}
            columnIndex={index}
            sortColumnIndex={tableData.sortColumnIndex}
            toggleCheckVal={toggleCheckVal}
            singleDeleteOperation={singleDeleteOperation}
            updateCrosstabGridTitleHeader={updateCrosstabGridTitleHeader}
            updateGridData={updateGridData}
            updateGridTitle={updateGridTitle}
            updatedTitleIndex={updatedTitleIndex}
            updatedTitleGridType={updatedTitleGridType}
            resetSelectedIndex={resetSelectedIndex}
            restoreGridTitle={restoreGridTitle}
            handleCrosstabEdit={handleCrosstabEdit}
            showFootNoteIcon={item.footnotes ? item.footnotes : []}
            crosstabFootNotes={crosstabFootNotes}
            partsToShow={partsToShow}
          />
        )),
      [
        columnHeaderList,
        sortClickToggle,
        tableData.sortOrder,
        tableData.sortKey,
        tableData.sortColumnIndex,
        toggleCheckVal.column,
        cellElementList,
        scrollStarted,
        updatedTitleIndex,
        updatedTitleGridType,
        crosstabFootNotes,
        editExpression,
        partsToShow,
      ]
    );
  };

  const renderFirstHeaderColumn = () => {
    return useMemo(
      () => (
        <FirstHeaderColumn
          handleCrosstabSaveButton={handleCrosstabSaveButton}
          highlightRadioButton={highlightRadioButton}
          onValueChange={saveTextChange}
          handleHighlightShowButton={handleHighlightShowButton}
          tableData={tableData}
          showSave
          placeholder={placeholder}
          warningText={warningText}
          columnHeight={setHeightOfColumns(partsToShow, columnHeaderList, toggleCheckVal)}
        />
      ),
      [toggleCheckVal.column, columnHeaderList]
    );
  };

  const renderCellHeaders = () => {
    return useMemo(
      () => (
        <PrivateEyeViewCellContent
          cellElementList={cellElementList}
          getGridRows={gridRows}
          colEndIndex={colEndIndex}
          highlightAndFilter={tableData.highlightAndFilter}
          toggleCheckVal={toggleCheckVal}
          handleProbabilitiesEditClick={handleProbabilitiesEditClick}
          partsToShow={partsToShow}
        />
      ),
      [cellElementList, gridRows, tableData.highlightAndFilter, toggleCheckVal.row, colEndIndex, partsToShow]
    );
  };

  const renderRowHeaders = () => {
    return useMemo(
      () => (
        <PrivateEyeViewRowHeaders
          getGridRows={gridRows}
          toggleCheckVal={toggleCheckVal}
          updateGridData={updateGridData}
          handleCrosstabEdit={handleCrosstabEdit}
          restoreGridTitle={restoreGridTitle}
          singleDeleteOperation={singleDeleteOperation}
          updateCrosstabGridTitleHeader={updateCrosstabGridTitleHeader}
          crosstabFootNotes={crosstabFootNotes}
          updatedTitleIndex={updatedTitleIndex}
          updateGridTitle={updateGridTitle}
          updatedTitleGridType={updatedTitleGridType}
          resetSelectedIndex={resetSelectedIndex}
          editExpression={editExpression}
          partsToShow={partsToShow}
        />
      ),
      [
        gridRows,
        editExpression,
        toggleCheckVal.row,
        crosstabFootNotes,
        updatedTitleIndex,
        updatedTitleGridType,
        partsToShow,
      ]
    );
  };

  const newRows = _.cloneDeep(gridRows);
  if ($('.empty-table-last-row').length !== 0) {
    $('.empty-table-last-row').remove();
  }
  if ($('.empty-table-header-col').length !== 0) {
    $('.empty-table-header-col').remove();
  }

  if (columnHeaderList && newRows) {
    return (
      <div>
        <div className="row expanded main-table">
          {renderFirstHeaderColumn()}
          <div id="top-header-column" className="column right-column-width c-table-container">
            <div className="c-table">
              <div className="c-table--header">
                <div className="c-table--row">{renderColumnHeader()}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="row expanded main-content-grid">
          <div className="column left-column-width main-content-grid-left" id="left-menu-content">
            {renderRowHeaders()}
          </div>
          <div
            id="main-content-grid"
            className="column right-column-width main-content-grid-right"
            onScroll={e => handleContentScroll(e)}
          >
            {renderCellHeaders()}
          </div>
        </div>
      </div>
    );
  }
  return '';
};

export default React.memo(PrivateEyeView);
